package repdb

import androidx.paging.PagingSource
import com.ustadmobile.door.DoorDbType
import com.ustadmobile.door.EntityInsertionAdapter
import com.ustadmobile.door.PreparedStatementConfig
import com.ustadmobile.door.entities.DoorNode
import com.ustadmobile.door.ext.createArrayOrProxyArrayOf
import com.ustadmobile.door.ext.prepareAndUseStatement
import com.ustadmobile.door.ext.prepareAndUseStatementAsync
import com.ustadmobile.door.flow.doorFlow
import com.ustadmobile.door.jdbc.PreparedStatement
import com.ustadmobile.door.jdbc.ext.executeQueryAsyncKmp
import com.ustadmobile.door.jdbc.ext.executeUpdateAsyncKmp
import com.ustadmobile.door.jdbc.ext.mapNextRow
import com.ustadmobile.door.jdbc.ext.mapRows
import com.ustadmobile.door.jdbc.ext.useResults
import com.ustadmobile.door.paging.DoorLimitOffsetPagingSource
import com.ustadmobile.door.room.RoomDatabase
import kotlin.Boolean
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow

public class RepDao_JdbcImpl(
  public val _db: RoomDatabase,
) : RepDao {
  public val _insertAdapterDoorNode_abort: EntityInsertionAdapter<DoorNode> = object :
      EntityInsertionAdapter<DoorNode>(_db) {
    override fun makeSql(returnsId: Boolean): String =
        "INSERT INTO DoorNode (auth, nodeId, rel) VALUES(?, ?, ?)"

    override fun bindPreparedStmtToEntity(stmt: PreparedStatement, entity: DoorNode) {
      stmt.setString(1, entity.auth)
      stmt.setLong(2, entity.nodeId)
      stmt.setInt(3, entity.rel)
    }
  }

  public val _insertAdapterRepEntity_abort: EntityInsertionAdapter<RepEntity> = object :
      EntityInsertionAdapter<RepEntity>(_db) {
    override fun makeSql(returnsId: Boolean): String =
        "INSERT INTO RepEntity (rePrimaryKey, reLastChangedBy, reLastChangeTime, reNumField, reString, reBoolean) VALUES(?, ?, ?, ?, ?, ?)"

    override fun bindPreparedStmtToEntity(stmt: PreparedStatement, entity: RepEntity) {
      if(entity.rePrimaryKey == 0L) {
        stmt.setObject(1, null)
      } else {
        stmt.setLong(1, entity.rePrimaryKey)
      }
      stmt.setLong(2, entity.reLastChangedBy)
      stmt.setLong(3, entity.reLastChangeTime)
      stmt.setInt(4, entity.reNumField)
      stmt.setString(5, entity.reString)
      stmt.setBoolean(6, entity.reBoolean)
    }
  }

  override suspend fun insertDoorNodeAsync(node: DoorNode) {
    _insertAdapterDoorNode_abort.insertAsync(node)
  }

  override fun insertDoorNode(node: DoorNode) {
    _insertAdapterDoorNode_abort.insert(node)
  }

  override suspend fun insertAsync(repEntity: RepEntity): Long {
    val _retVal = _insertAdapterRepEntity_abort.insertAndReturnIdAsync(repEntity)
    return _retVal
  }

  override fun insert(repEntity: RepEntity): Long {
    val _retVal = _insertAdapterRepEntity_abort.insertAndReturnId(repEntity)
    return _retVal
  }

  override fun insertList(repEntityList: List<RepEntity>) {
    _insertAdapterRepEntity_abort.insertList(repEntityList)
  }

  override suspend fun insertHttp(entity: RepEntity): Long {
    val _retVal = _insertAdapterRepEntity_abort.insertAndReturnIdAsync(entity)
    return _retVal
  }

  public override fun interfaceInsertFun(entity: RepEntity) {
    _insertAdapterRepEntity_abort.insert(entity)
  }

  override fun update(repEntity: RepEntity) {
    val _sql =
        "UPDATE RepEntity SET reLastChangedBy = ?, reLastChangeTime = ?, reNumField = ?, reString = ?, reBoolean = ? WHERE rePrimaryKey = ?"
    _db.prepareAndUseStatement(_sql) {
       _stmt ->
      _stmt.setLong(1, repEntity.reLastChangedBy)
      _stmt.setLong(2, repEntity.reLastChangeTime)
      _stmt.setInt(3, repEntity.reNumField)
      _stmt.setString(4, repEntity.reString)
      _stmt.setBoolean(5, repEntity.reBoolean)
      _stmt.setLong(6, repEntity.rePrimaryKey)
      _stmt.executeUpdate()
    }
  }

  override suspend fun updateAsync(repEntity: RepEntity) {
    val _sql =
        "UPDATE RepEntity SET reLastChangedBy = ?, reLastChangeTime = ?, reNumField = ?, reString = ?, reBoolean = ? WHERE rePrimaryKey = ?"
    _db.prepareAndUseStatementAsync(_sql) {
       _stmt ->
      _stmt.setLong(1, repEntity.reLastChangedBy)
      _stmt.setLong(2, repEntity.reLastChangeTime)
      _stmt.setInt(3, repEntity.reNumField)
      _stmt.setString(4, repEntity.reString)
      _stmt.setBoolean(5, repEntity.reBoolean)
      _stmt.setLong(6, repEntity.rePrimaryKey)
      _stmt.executeUpdateAsyncKmp()
    }
  }

  override fun countEntities(): Int = _db.prepareAndUseStatement(PreparedStatementConfig(
    sql = """
    |
    |    SELECT COUNT(*)
    |      FROM RepEntity
    |    
    """.trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.executeQuery().useResults{ _result -> 
      _result.mapNextRow(0) {
        _result.getInt(1)
      }
    }
  }

  override fun findByUid(uid: Long): RepEntity? =
      _db.prepareAndUseStatement(PreparedStatementConfig(
    sql = """
    |
    |    SELECT RepEntity.*
    |      FROM RepEntity
    |     WHERE RepEntity.rePrimaryKey = CAST(? AS BIGINT) 
    |    
    """.trimMargin(),
    postgreSql = """
    |
    |    SELECT RepEntity.*
    |      FROM RepEntity
    |     WHERE RepEntity.rePrimaryKey = ? 
    |    
    |""".trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.setLong(1,uid)
    _stmt.executeQuery().useResults{ _result -> 
      _result.mapNextRow(null) {
        val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
        val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
        val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
        val _tmp_reNumField = _result.getInt("reNumField")
        val _tmp_reString = _result.getString("reString")
        val _tmp_reBoolean = _result.getBoolean("reBoolean")
        RepEntity().apply {
          this.rePrimaryKey = _tmp_rePrimaryKey
          this.reLastChangedBy = _tmp_reLastChangedBy
          this.reLastChangeTime = _tmp_reLastChangeTime
          this.reNumField = _tmp_reNumField
          this.reString = _tmp_reString
          this.reBoolean = _tmp_reBoolean
        }
      }
    }
  }

  override suspend fun findByUidAsync(uid: Long): RepEntity? =
      _db.prepareAndUseStatementAsync(PreparedStatementConfig(
    sql = """
    |
    |    SELECT RepEntity.*
    |      FROM RepEntity
    |     WHERE RepEntity.rePrimaryKey = CAST(? AS BIGINT) 
    |    
    """.trimMargin(),
    postgreSql = """
    |
    |    SELECT RepEntity.*
    |      FROM RepEntity
    |     WHERE RepEntity.rePrimaryKey = ? 
    |    
    |""".trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.setLong(1,uid)
    _stmt.executeQueryAsyncKmp().useResults{ _result -> 
      _result.mapNextRow(null) {
        val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
        val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
        val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
        val _tmp_reNumField = _result.getInt("reNumField")
        val _tmp_reString = _result.getString("reString")
        val _tmp_reBoolean = _result.getBoolean("reBoolean")
        RepEntity().apply {
          this.rePrimaryKey = _tmp_rePrimaryKey
          this.reLastChangedBy = _tmp_reLastChangedBy
          this.reLastChangeTime = _tmp_reLastChangeTime
          this.reNumField = _tmp_reNumField
          this.reString = _tmp_reString
          this.reBoolean = _tmp_reBoolean
        }
      }
    }
  }

  override suspend fun findAllAsync(): List<RepEntity> =
      _db.prepareAndUseStatementAsync(PreparedStatementConfig(
    sql = """
    |
    |    SELECT RepEntity.*
    |      FROM RepEntity
    |    
    """.trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.executeQueryAsyncKmp().useResults{ _result -> 
      _result.mapRows {
        val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
        val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
        val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
        val _tmp_reNumField = _result.getInt("reNumField")
        val _tmp_reString = _result.getString("reString")
        val _tmp_reBoolean = _result.getBoolean("reBoolean")
        RepEntity().apply {
          this.rePrimaryKey = _tmp_rePrimaryKey
          this.reLastChangedBy = _tmp_reLastChangedBy
          this.reLastChangeTime = _tmp_reLastChangeTime
          this.reNumField = _tmp_reNumField
          this.reString = _tmp_reString
          this.reBoolean = _tmp_reBoolean
        }
      }
    }
  }

  override suspend fun selectSyncNodeId(): Long =
      _db.prepareAndUseStatementAsync(PreparedStatementConfig(
    sql = """
    |
    |        SELECT COALESCE(
    |                    (SELECT nodeClientId 
    |                       FROM SyncNode 
    |                      LIMIT 1), 0)
    |    
    """.trimMargin(),
    readOnly = true,)
  ) { _stmt -> 
    _stmt.executeQueryAsyncKmp().useResults{ _result -> 
      _result.mapNextRow(0L) {
        _result.getLong(1)
      }
    }
  }

  override suspend fun findInStringList(strList: List<String>): List<RepEntity> =
      _db.prepareAndUseStatementAsync(PreparedStatementConfig(
    sql = """
    |
    |        SELECT RepEntity.*
    |          FROM RepEntity
    |         WHERE reString IN (?) 
    |    
    """.trimMargin(),
    hasListParams = true,
    readOnly = true,)
  ) { _stmt -> 
    _stmt.setArray(1, _stmt.getConnection().createArrayOrProxyArrayOf("TEXT",
        strList.toTypedArray()))
    _stmt.executeQueryAsyncKmp().useResults{ _result -> 
      _result.mapRows {
        val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
        val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
        val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
        val _tmp_reNumField = _result.getInt("reNumField")
        val _tmp_reString = _result.getString("reString")
        val _tmp_reBoolean = _result.getBoolean("reBoolean")
        RepEntity().apply {
          this.rePrimaryKey = _tmp_rePrimaryKey
          this.reLastChangedBy = _tmp_reLastChangedBy
          this.reLastChangeTime = _tmp_reLastChangeTime
          this.reNumField = _tmp_reNumField
          this.reString = _tmp_reString
          this.reBoolean = _tmp_reBoolean
        }
      }
    }
  }

  override suspend fun sqliteOnlyFun(num1: Int, num2: Int): Long =
      _db.prepareAndUseStatementAsync(PreparedStatementConfig(
    sql = "SELECT MAX(?, ?)",
    readOnly = true,)
  ) { _stmt -> 
    _stmt.setInt(1,num1)
    _stmt.setInt(2,num2)
    _stmt.executeQueryAsyncKmp().useResults{ _result -> 
      _result.mapNextRow(0L) {
        _result.getLong(1)
      }
    }
  }

  override fun findAllAsFlow(): Flow<List<RepEntity>> = _db.doorFlow(arrayOf("RepEntity")) {
    _db.prepareAndUseStatementAsync(PreparedStatementConfig(
      sql = """
      |
      |        SELECT * FROM RepEntity
      |    
      """.trimMargin(),
      readOnly = true,)
    ) { _stmt -> 
      _stmt.executeQueryAsyncKmp().useResults{ _result -> 
        _result.mapRows {
          val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
          val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
          val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
          val _tmp_reNumField = _result.getInt("reNumField")
          val _tmp_reString = _result.getString("reString")
          val _tmp_reBoolean = _result.getBoolean("reBoolean")
          RepEntity().apply {
            this.rePrimaryKey = _tmp_rePrimaryKey
            this.reLastChangedBy = _tmp_reLastChangedBy
            this.reLastChangeTime = _tmp_reLastChangeTime
            this.reNumField = _tmp_reNumField
            this.reString = _tmp_reString
            this.reBoolean = _tmp_reBoolean
          }
        }
      }
    }
  }

  override fun findAllPaged(): PagingSource<Int, RepEntity> = object :
      DoorLimitOffsetPagingSource<RepEntity>(db = _db
  , tableNames = arrayOf("RepEntity")
  ) {
    override suspend fun loadRows(_limit: Int, _offset: Int): List<RepEntity> =
        _db.prepareAndUseStatementAsync(PreparedStatementConfig(
      sql = """
      |SELECT * FROM (
      |        SELECT * FROM RepEntity
      |    ) AS _PagingData LIMIT ? OFFSET ?
      """.trimMargin(),
      readOnly = true,)
    ) { _stmt -> 
      _stmt.setInt(1,_limit)
      _stmt.setInt(2,_offset)
      _stmt.executeQueryAsyncKmp().useResults{ _result -> 
        _result.mapRows {
          val _tmp_rePrimaryKey = _result.getLong("rePrimaryKey")
          val _tmp_reLastChangedBy = _result.getLong("reLastChangedBy")
          val _tmp_reLastChangeTime = _result.getLong("reLastChangeTime")
          val _tmp_reNumField = _result.getInt("reNumField")
          val _tmp_reString = _result.getString("reString")
          val _tmp_reBoolean = _result.getBoolean("reBoolean")
          RepEntity().apply {
            this.rePrimaryKey = _tmp_rePrimaryKey
            this.reLastChangedBy = _tmp_reLastChangedBy
            this.reLastChangeTime = _tmp_reLastChangeTime
            this.reNumField = _tmp_reNumField
            this.reString = _tmp_reString
            this.reBoolean = _tmp_reBoolean
          }
        }
      }
    }

    override suspend fun countRows(): Int = _db.prepareAndUseStatementAsync(PreparedStatementConfig(
      sql = """
      |SELECT COUNT(*) FROM (
      |        SELECT * FROM RepEntity
      |    ) AS _PagingCount
      """.trimMargin(),
      readOnly = true,)
    ) { _stmt -> 
      _stmt.executeQueryAsyncKmp().useResults{ _result -> 
        _result.mapNextRow(0) {
          _result.getInt(1)
        }
      }
    }
  }
}
